export const ChannelConfigurationFragment = `
  fragment ChannelConfigurationFragment on ChannelConfiguration {
    EMAIL {
      enabled
    }
    IN_APP {
      enabled
    }
    SLACK {
      enabled
      slackChannels
      integrationInstanceId
    }
  }
`;
